<template>
  <div class="login" :style="{ backgroundImage: `url(${bgUrl})` }">
    <div class="login-panel">
      <!-- 公司大标题 -->
      <h1 class="company">上海家禽育种有限公司</h1>
      <div class="login-box">
        <h2 class="title">种鸡育种管理系统</h2>
        <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @submit.prevent>
          <el-form-item label="用户名" prop="account">
            <el-input v-model="form.account" placeholder="请输入用户名或邮箱" clearable @keyup.enter="handleLogin" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              show-password
              @keyup.enter="handleLogin"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit" :loading="loading" @click="handleLogin">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import bgUrl from '@/assets/login-bg.png'
import { userApi } from '@/api'
import { setAuth } from '@/api/auth'

const router = useRouter()
const route = useRoute()
const formRef = ref()
const loading = ref(false)
const form = reactive({ account: '', password: '' })

const rules = {
  account: [{ required: true, message: '请输入用户名或邮箱', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
}

const handleLogin = async () => {
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid || loading.value) return
  loading.value = true
  try {
    // 后端校验通过后返回 token + 用户信息,后续请求由 request.js 自动携带 token
    const { token, user } = await userApi.login({ account: form.account, password: form.password })
    setAuth(token, user)
    ElMessage.success('登录成功')
    router.push(route.query.redirect || '/')
  } catch (e) {
    // 接口异常信息已由 request.js 统一提示,此处仅阻断流程
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login {
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
/* margin: auto 实现水平垂直居中,内容高出屏幕时也不会顶部被裁 */
.login-panel {
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-box {
  width: 100%;
  max-width: 360px;
  padding: 30px 35px 10px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}
.company {
  margin: 0 0 24px;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55);
}
.title {
  margin: 0 0 20px;
  text-align: center;
  font-size: 20px;
  color: #303133;
}
.submit {
  width: 100%;
}
/* 移动端适配:登录框仍垂直居中,标题缩小、表单铺满屏宽 */
@media (max-width: 768px) {
  .company {
    margin-bottom: 16px;
    font-size: 24px;
    letter-spacing: 1px;
  }
  .title {
    margin-bottom: 14px;
    font-size: 17px;
  }
  .login-box {
    padding: 20px 18px 0;
  }
  /* 输入框字体≥16px,避免 iOS 聚焦时自动放大页面 */
  .login-box :deep(.el-input__inner) {
    font-size: 16px;
  }
}
</style>
